 
document.addEventListener('DOMContentLoaded', function() {

// Pricing update functions
function updateMainPricing(isSubscription) {
  const regularPriceEl = document.getElementById('regular-price');
  const comparePriceEl = document.getElementById('compare-price');
  const savingsEl = document.getElementById('savings-amount');
  
  if (!window.pricingData) {
    console.warn('Pricing data not available');
    return;
  }
  
  if (isSubscription) {
    regularPriceEl.textContent = window.pricingData.subscription.priceFormatted;
    comparePriceEl.textContent = window.pricingData.subscription.comparePriceFormatted;
    savingsEl.textContent = 'Save ' + window.pricingData.subscription.savingsFormatted;
    comparePriceEl.style.display = 'inline';
    savingsEl.style.display = 'inline';
  } else {
    regularPriceEl.textContent = window.pricingData.original.priceFormatted;
    if (window.pricingData.original.comparePrice > window.pricingData.original.price) {
      comparePriceEl.textContent = window.pricingData.original.comparePriceFormatted;
      const originalSavings = window.pricingData.original.comparePrice - window.pricingData.original.price;
      savingsEl.textContent = 'Save $' + (originalSavings / 100).toFixed(2);
      comparePriceEl.style.display = 'inline';
      savingsEl.style.display = 'inline';
    } else {
      comparePriceEl.style.display = 'none';
      savingsEl.style.display = 'none';
    }
  }
}

// Custom dropdown functionality
function initCustomDropdown() {
  const mainSelector = document.querySelector('.active-dropdown-value.subscription-dropdown-row');
  const mainSelectorValue = document.querySelector('.active-dropdown-value span');
  const mainDropDown = document.querySelector('custom-dropdown ul');
  const mainDropDownValue = document.querySelectorAll('custom-dropdown ul li');
  const customDropdownContainer = document.querySelector('custom-dropdown');

  if (mainSelector && mainDropDown) {
    console.log('Dropdown elements found, setting up click handler');
    
    mainSelector.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Dropdown clicked, toggling active class');
      
      // Toggle the dropdown
      const isActive = mainDropDown.classList.contains('active');
      
      if (isActive) {
        mainDropDown.classList.remove('active');
        mainSelector.classList.remove('active');
        if (customDropdownContainer) {
          customDropdownContainer.classList.remove('active');
        }
        console.log('Dropdown closed');
      } else {
        mainDropDown.classList.add('active');
        mainSelector.classList.add('active');
        if (customDropdownContainer) {
          customDropdownContainer.classList.add('active');
        }
        console.log('Dropdown opened');
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!customDropdownContainer?.contains(e.target)) {
        mainDropDown.classList.remove('active');
        mainSelector.classList.remove('active');
        if (customDropdownContainer) {
          customDropdownContainer.classList.remove('active');
        }
      }
    });
  } else {
    console.log('Dropdown elements not found:', {
      mainSelector: !!mainSelector,
      mainDropDown: !!mainDropDown
    });
  }
}

// Initialize dropdown after DOM is ready
initCustomDropdown();

// Setup dropdown item click handlers
function initDropdownItemHandlers() {
  const mainSelector = document.querySelector('.active-dropdown-value');
  const mainSelectorValue = document.querySelector('.active-dropdown-value span');
  const mainDropDown = document.querySelector('custom-dropdown ul');
  const mainDropDownValue = document.querySelectorAll('custom-dropdown ul li');
  const customDropdownContainer = document.querySelector('custom-dropdown');

  if (mainDropDownValue.length) {
    mainDropDownValue.forEach(li => {
      li.addEventListener('click', function(e) {
        e.stopPropagation();
        
        const spanText = this.querySelector('span.plan-name')?.innerText;
        console.log('Dropdown item clicked:', spanText);

        const ID = this.getAttribute('data-plan-id')?.trim();
        const freqDropdown = document.getElementById('subscription-frequency');
        const options = document.querySelectorAll('#subscription-frequency option');

        console.log('Looking for plan ID:', ID);

        let matchedOption = null;

        // Loop through all options to find the matching one
        options.forEach(option => {
          const optionPlanId = option.getAttribute('data-plan-id')?.trim();
          console.log('Comparing with option plan ID:', optionPlanId);
          
          if (optionPlanId === ID) {
            matchedOption = option;
            option.setAttribute('selected', 'selected');
          } else {
            option.removeAttribute('selected');
          }
        });

        // Set the dropdown value using the matched option
        if (matchedOption && freqDropdown) {
          const optionValue = matchedOption.value?.trim();
          freqDropdown.value = optionValue;
          console.log('Setting dropdown value to:', optionValue);
        } else if (freqDropdown && spanText) {
          // Fallback: try to match by text content
          console.log('Plan ID match failed, trying text match for:', spanText);
          const cleanSpanText = spanText.trim();
          
          for (let i = 0; i < freqDropdown.options.length; i++) {
            const option = freqDropdown.options[i];
            const optionText = option.text?.trim();
            
            // Try exact match first
            if (optionText === cleanSpanText) {
              freqDropdown.selectedIndex = i;
              console.log('Matched by exact text:', optionText);
              break;
            }
            
            // Try partial match (removing "Every " prefix)
            const cleanOptionText = optionText?.replace(/^Every\s+/i, '');
            const cleanSpanTextNoEvery = cleanSpanText?.replace(/^Every\s+/i, '');
            
            if (cleanOptionText === cleanSpanTextNoEvery) {
              freqDropdown.selectedIndex = i;
              console.log('Matched by partial text:', cleanOptionText);
              break;
            }
          }
        }
        
        // Trigger the change event on the subscription-frequency select
        if (freqDropdown) {
          freqDropdown.dispatchEvent(new Event('change', { bubbles: true }));
          console.log("trigger change event");
        }
        
        // Update the main selector text
        if (mainSelectorValue && spanText) {
          mainSelectorValue.innerHTML = spanText.trim();
        }
        
        // Update pricing data with selected plan
        if (ID) {
          updatePricingDataFromSellingPlan(ID);
        }

        // Close dropdown
        if (mainDropDown) {
          mainDropDown.classList.remove('active');
        }
        if (mainSelector) {
          mainSelector.classList.remove('active');
        }
        if (customDropdownContainer) {
          customDropdownContainer.classList.remove('active');
        }
      });
    });
  }
}

// Initialize dropdown item handlers
initDropdownItemHandlers();

// Radio button event listeners for pricing updates
const radios = document.querySelectorAll('.subscription-radio-option input[type="radio"]');
radios.forEach(radio => {
  radio.addEventListener('change', function() {
    const isSubscription = this.value === 'subscribe';
    updateMainPricing(isSubscription);
  });
});

// Function to update pricing data based on selected selling plan
function updatePricingDataFromSellingPlan(sellingPlanId) {
  if (window.refillProductData && window.refillProductData.sellingPlans) {
    const selectedPlan = window.refillProductData.sellingPlans.find(plan => {
      return plan.id.toString() === sellingPlanId;
    });
    
    if (selectedPlan && window.pricingData) {
      // Get subscription pricing from selling plan allocation
      const subscriptionPrice = selectedPlan.price.replace(/[^0-9.-]+/g, "") * 100; // Convert to cents
      const subscriptionComparePrice = selectedPlan.compare_at_price.replace(/[^0-9.-]+/g, "") * 100; // Convert to cents
      const savingsAmount = subscriptionComparePrice - subscriptionPrice;
      const discountPercent = subscriptionComparePrice > 0 ? Math.round((savingsAmount / subscriptionComparePrice) * 100) : 0;
      
      // Update the pricing data object with selling plan prices
      window.pricingData.subscription = {
        price: subscriptionPrice,
        comparePrice: subscriptionComparePrice,
        priceFormatted: selectedPlan.price,
        comparePriceFormatted: selectedPlan.compare_at_price,
        savingsAmount: savingsAmount,
        savingsFormatted: '$' + (savingsAmount / 100).toFixed(2),
        discountPercent: discountPercent
      };
      
      // Update main pricing if subscription is currently selected
      const checkedRadio = document.querySelector('input[name="offer_type"]:checked');
      if (checkedRadio && checkedRadio.value === 'subscribe') {
        updateMainPricing(true);
      }
    }
  }
}

// Frequency dropdown functionality
const freqDropdown = document.getElementById('subscription-frequency');
const freqLabel = document.querySelector('.subscription-frequency-label');

if (freqDropdown) {
  freqDropdown.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    
    // Check if selectedOption exists before accessing its properties
    if (!selectedOption) {
      console.warn('No selected option found in subscription frequency dropdown');
      return;
    }
    
    const selectedText = selectedOption.text;
    const selectedPlanId = selectedOption.getAttribute('data-plan-id');
    
    if (freqLabel && selectedText) {
      freqLabel.textContent = selectedText.replace(/^Every\s+/i, '');
    }
    const refillwashDesc = document.querySelectorAll(".refill_wash_description");
    
    if (selectedText) {
      const selectedMonth = selectedText.replace(/^Every\s+/i, '').replace(/\s*months?/i, '');

      refillwashDesc.forEach((ele) => {
        const value = ele.getAttribute("value");
        ele.classList.add("hidden");
        
        if (parseInt(value) === parseInt(selectedMonth)) {
          ele.classList.remove("hidden");
        }
      });
    }

    // Update pricing data and main pricing display
    if (selectedPlanId) {
      updatePricingDataFromSellingPlan(selectedPlanId);
    }

    // Update refill product pricing when frequency changes
    if (window.refillProductData && window.refillProductData.sellingPlans) {
      const selectedPlan = window.refillProductData.sellingPlans.find(plan => {
        return plan.id.toString() === selectedPlanId;
      });
      
      if (selectedPlan) {
        const refillPriceEl = document.querySelector('.pay_freq_price_wrapper .subscription-price');
        const refillComparePriceEl = document.querySelector('.pay_freq_price_wrapper .subscription-compare-price');
        
        if (refillPriceEl) {
          refillPriceEl.textContent = selectedPlan.price;
        }
        
        if (refillComparePriceEl && selectedPlan.compare_at_price) {
          refillComparePriceEl.textContent = selectedPlan.compare_at_price;
        }
      }
    }
  });
  
  // Initialize the frequency label on page load
  const selectedOption = freqDropdown.options[freqDropdown.selectedIndex];
  if (selectedOption && freqLabel) {
    const selectedText = selectedOption.text;
    freqLabel.textContent = selectedText.replace(/^Every\s+/i, '');
  }
  
  // Initialize refill product pricing on page load
  if (window.refillProductData && window.refillProductData.sellingPlans && freqDropdown) {
    const selectedPlanId = freqDropdown.options[freqDropdown.selectedIndex]?.getAttribute('data-plan-id');
    
    if (selectedPlanId) {
      // Update pricing data with initial selected plan
      updatePricingDataFromSellingPlan(selectedPlanId);
    }
    
    const selectedPlan = window.refillProductData.sellingPlans.find(plan => {
      return plan.id.toString() === selectedPlanId;
    });
    
    if (selectedPlan) {
      const refillPriceEl = document.querySelector('.pay_freq_price_wrapper .subscription-price');
      const refillComparePriceEl = document.querySelector('.pay_freq_price_wrapper .subscription-compare-price');
      
      if (refillPriceEl) {
        refillPriceEl.textContent = selectedPlan.price;
      }
      
      if (refillComparePriceEl && selectedPlan.compare_at_price) {
        refillComparePriceEl.textContent = selectedPlan.compare_at_price;
      }
    }
  }
}

    // Initialize pricing on page load (subscription is checked by default)
    setTimeout(() => {
      // First initialize with selling plan data if available
      const freqDropdown = document.getElementById('subscription-frequency');
      if (freqDropdown && window.refillProductData) {
        const selectedPlanId = freqDropdown.options[freqDropdown.selectedIndex]?.getAttribute('data-plan-id');
        if (selectedPlanId) {
          updatePricingDataFromSellingPlan(selectedPlanId);
        }
      }
      
      // Then update the main pricing display
      updateMainPricing(true);
    }, 100);

    document.querySelectorAll('.subscription-offer-box').forEach(sub_offer_box => {
      sub_offer_box.addEventListener('click', () => {
        console.log('mainn elsee');
        sub_offer_box.classList.add('active');

        // Find and select the subscription radio button
        const subscriptionRadio = document.querySelector('input[name="offer_type"][value="subscribe"]');
        if (subscriptionRadio) {
          subscriptionRadio.checked = true;
          // Trigger change event to update pricing and other functionality
          subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        document.querySelectorAll('.subscription-radio-option')
          .forEach(one_offer_box => one_offer_box.classList.remove('active'));
      });
    });

    document.querySelectorAll('.subscription-radio-option').forEach(one_offer_box => {
      one_offer_box.addEventListener('click', () => {
        console.log('mainn iff');
        one_offer_box.classList.add('active');

        // Find and select the one-time radio button
        const onetimeRadio = document.querySelector('input[name="offer_type"][value="onetime"]');
        if (onetimeRadio) {
          onetimeRadio.checked = true;
          // Trigger change event to update pricing and other functionality
          onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        document.querySelectorAll('.subscription-offer-box')
          .forEach(sub_offer_box => sub_offer_box.classList.remove('active'));
      });
    });


    // Get all kit options
    const kitOptions = document.querySelectorAll('.subscription-module .kit-option');
    const defaultRadio = document.querySelector('input[name="offer_type"]:checked');
    const subscriptionBox = document.querySelector('.subscription-offer-box');
    if (defaultRadio && subscriptionBox) {
      if (defaultRadio.value === 'subscribe') {
        subscriptionBox.classList.add('active');
      } else {
        subscriptionBox.classList.remove('active');
      }
    }

  const selectEl = document.querySelector('#subscription-frequency');
  const sellingPlanInput = document.querySelector('[name="selling_plan"]');

   if (selectEl && sellingPlanInput) {
      setTimeout(() => {
        const selectedOption = selectEl.querySelector("option[selected]");
        const sellingId = selectedOption ? selectedOption.getAttribute('data-plan-id') : null;

        if (sellingId) {
          sellingPlanInput.value = sellingId;
        }
      }, 150);

 
    selectEl.addEventListener('change', () => {
      setTimeout(() => {
        const selectedOption = selectEl.querySelector("option[selected]");
        const sellingId = selectedOption ? selectedOption.getAttribute('data-plan-id') : null;

        if (sellingId) {
          sellingPlanInput.value = sellingId;
        }
        
      }, 150);
    });
  }
  fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        console.log(cart, "cart");
        
        // Check for orphaned refill products on page load
        console.log('Checking for orphaned refill products on subscription page load...');
        checkAndRemoveOrphanedRefillProducts()
          .then(updatedCart => {
            if (updatedCart) {
              console.log('Found and removed orphaned refill products on subscription page load');
            }
          })
          .catch(error => {
            console.error('Error checking orphaned refill products on page load:', error);
          });
      });
      
    // Patch add_to_cart for subscription logic
    async function add_to_cart(event, type) {
      event.preventDefault();
      
      // Get the clicked button
      const button = event.currentTarget;
      const originalText = button.textContent;
      
      // Set loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      button.textContent = type === 'buy_now' ? 'Processing...' : 'Adding...';
      
      const checkedInput = document.querySelector('[name="offer_type"]:checked');
      const offerType = checkedInput ? checkedInput.value : null;
      const inputEl = document.querySelector('[name="id"]');
      const variantId = inputEl ? inputEl.value : null;
      const selectEl = document.querySelector('#subscription-frequency');
      const selectedOption = selectEl ? selectEl.querySelector("option[selected]") : null;
      const sellingPlanId = selectedOption ? selectedOption.getAttribute('data-plan-id') : null;
console.log(sellingPlanId, "sellingPlanId");

      const items = [];
      if (offerType === 'subscribe') {
        items.push({
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlanId,
        });
        
      } else {
        // One-time: just add kit
        items.push({
          id: variantId,
          quantity: 1
        });
      }
      console.log(items, "items");
      
      // Use Fetch API instead of jQuery
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => response.json())
      .then(data => {
        // Fetch complete cart data to get item_count
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cartData => {

        if (type == "buy_now") {
            // Show success state briefly before redirect
            button.textContent = 'Redirecting...';
            setTimeout(() => {
              window.location.href = '/checkout';
            }, 500);
          } else {
            // Show success state
            button.textContent = 'Added!';
            button.style.opacity = '1';
            
            if (window.updateCart) {
                window.updateCart(cartData);
            }
            // Update cart count if you have a cart counter
            if (typeof window.updateCartCount === 'function') {
                window.updateCartCount();
            }
            
            // Open cart drawer
            if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer();
            }
            
            // Reset button state after 2 seconds
            setTimeout(() => {
                button.disabled = false;
                button.style.opacity = '1';
                button.style.cursor = 'pointer';
                button.textContent = originalText;
            }, 2000);
          }
      })
      .catch((error) => {
        console.log(error, "error");
        
        // Show error state
        button.textContent = 'Error - Try Again';
        button.style.opacity = '1';
        
        // Reset button state after 3 seconds
        setTimeout(() => {
            button.disabled = false;
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
            button.textContent = originalText;
        }, 3000);
      });
    }
  
    if(document.querySelectorAll('.add_to_cart').length) {
      document.querySelectorAll('.add_to_cart').forEach((ele) => {
        ele.addEventListener('click',function(e){
            e.preventDefault();
          add_to_cart(e, "add_to_cart");
        })  
      });
    }

    if(document.querySelectorAll('.buy_now').length) {
      document.querySelectorAll('.buy_now').forEach((ele) => {
        ele.addEventListener('click',function(e){
          add_to_cart(e, "buy_now");
          console.log('ifff')
        })  
      });
    }
    // --- SUBSCRIPTION BUNDLE LOGIC END ---
    
  
    
})